import { render } from "./ModalWin.vue?vue&type=template&id=3371b018&scoped=true"
import script from "./ModalWin.vue?vue&type=script&lang=js"
export * from "./ModalWin.vue?vue&type=script&lang=js"

import "./ModalWin.vue?vue&type=style&index=0&id=3371b018&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3371b018"]])

export default __exports__